'use client';

import { Checkbox } from '@coolblue-development/freddy';
import deselectFilterTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilter/deselectFilterTrigger';
import selectFilterTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilter/selectFilterTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { FilterCategories, FilterOption } from '@server/careers-backend/search';

type Props = {
  filterCategory: FilterCategories;
  option: FilterOption<string>;
  subFeature: 'filter_overlay' | 'filter_list';
};

export const CheckboxItem = ({ filterCategory, option, subFeature }: Props) => {
  const { trackEvent } = useAnalytics();

  return (
    <Checkbox
      label={option.displayName}
      description={option.hideCount ? `` : `(${option.count})`}
      value={option.filterKey}
      onClick={e => {
        const checked = (e.target as HTMLInputElement)?.checked;
        const payload = {
          sub_feature: subFeature,
          filter_name: filterCategory,
          filter_value: option.displayName,
          is_recommended: true
        };

        if (checked) {
          trackEvent(selectFilterTrigger({ ...payload, number_of_items: option.count }));
        } else {
          trackEvent(deselectFilterTrigger({ ...payload, number_of_items: option.count })); // Todo: shouldn't be option.count but the total of pages of after deselection
        }
      }}
    />
  );
};
